/*
    Created By Sharifuzzaman Nakib on 07/12/2021
*/

export class DateUtility{
    public static isValidDate(date: any): boolean{
        return date instanceof Date && !isNaN(date.getTime());
    }

    public static isValidDateString(date: any):boolean{
        return (typeof date) === 'string' && !isNaN(Date.parse(date as string));
    }

    public static isValidDateStringOrObject(date:any):boolean{
        return this.isValidDate(date) || this.isValidDateString(date);
    }
}